<template>
  <Layout>
    <v-container
      slot="content"
      color="#21343b"
      class="container-detail"
      fluid
      v-if="isLoaded"
      :key="refreshKey"
      :style="isInIframe ? 'width: 100% !important; height: 100% !important; align-items: center' : ''"
      @mouseover="upHere = true"
      @mouseleave="upHere = false"
    >
      <div
        :class="
          this.totalSectionList && this.totalSectionList.length > 1
            ? 'container-detail-template multi-section'
            : 'container-detail-template one-section'
        "
        :style="isInIframe ? 'max-height: 100vh; max-width: 178vh' : ''"
      >
        <detail-template
          :isLoaded.sync="isLoaded"
          :upHere.sync="upHere"
          @openDialog="openDialog"
          @refreshData="refreshData"
        ></detail-template>
      </div>
      <attendee-dialog
        v-if="attendeeVisible"
        @close="closeDialog"
        :attendeeVisible.sync="attendeeVisible"
        :mtInfo.sync="currentMt"
      ></attendee-dialog>
      <!-- <floating-controller :mtId.sync="mtId" :wsId.sync="wsId" @uploadFinish="getMtInfo"></floating-controller> -->
      <!-- <floating-controller
        ref="floatingController"
        :mtId.sync="mtId"
        :wsId.sync="wsId"
        @uploadFinish="getMtInfo"
        @refreshData="refreshData"
      ></floating-controller>
      <upload-progress
        v-if="isShowProgressDialog"
        :isShowProgressDialog="isShowProgressDialog"
        :isChromeExtensionUpload.sync="isChromeExtensionUpload"
        :wsId.sync="wsId"
        :mtId.sync="mtId"
        :blob.sync="blob"
        :thumbnail.sync="thumbnail"
        :clipType.sync="clipType"
        :clipTitle.sync="clipTitle"
        :duration.sync="duration"
        @finish="isShowProgressDialog = false"
      ></upload-progress> -->
      <share-dialog v-if="isShareDialog" @close="closeDialog" :isShareDialog.sync="isShareDialog"></share-dialog>
      <move-to-dialog v-if="isMoveToDialog" @close="closeDialog" :isMoveToDialog.sync="isMoveToDialog"></move-to-dialog>
      <move-preference-dialog></move-preference-dialog>
    </v-container>
  </Layout>
</template>
<script>
import Layout from '@/views/Meeting'
import DetailTemplate from '@/views/meeting/component/detail/DetailTemplate'
import AttendeeDialog from '@/views/modal/AttendeeDialog'
// import FloatingController from '@/views/meeting/component/FloatingController'
import { getMtInfo, getClipList, getPublicMtInfo, getPublicMtClip } from '@/services/meetingApi'
import store from '@/store'
import ShareDialog from '@/views/modal/ShareDialog'
import { getSessionId } from '@/common/common'
import MoveToDialog from '@/views/modal/MoveToDialog'
import { isMobile } from '@/common/lib/strLib'
import MovePreferenceDialog from '@/views/modal/MovePreferenceDialog.vue'
import { mapGetters } from 'vuex'
// import UploadProgress from '@/views/meeting/component/record/UploadProgress'
import Toast from '@/views/meeting/component/Toast'

export default {
  components: {
    AttendeeDialog,
    Layout,
    // FloatingController,
    ShareDialog,
    MoveToDialog,
    DetailTemplate,
    MovePreferenceDialog,
    // UploadProgress,
  },
  created() {
    this.getMtInfo()

    // Extension 에서 업로드한 클립이 있는지 여부 체크
    // this.checkIndexedDBClip()

    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '미팅 상세',
        firebase_screen_class: 'Detail',
      },
    })
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'view_meeting',
      eventParam: {
        name: 'view_meeting',
        methodType: location.pathname.includes('share') ? 'share_link' : 'normal',
      },
    })
  },
  data() {
    return {
      drawer: localStorage.getItem('shortcut') == 'false' || this.userInfo == null ? false : true,
      isLoaded: false,

      // Extension 관련 변수
      // wsId: '',
      // mtId: this.$route.params.mtId,
      // thumbnail: '',
      // blob: null,
      // clipType: '',
      // duration: 0,
      // clipTitle: '',
      // setTime: 0,
      // mtInfo: {},
      clipList: [],
      attendeeVisible: false,
      refreshKey: false,
      videoSize: {
        width: 0,
        height: 0,
      },
      // isChromeExtensionUpload: true,
      isShareDialog: false,
      isMoveToDialog: false,
      path: 'https://file.tape.ooo/clip/',
      upHere: true,
      checked: 'dragtocomment',

      // Chrome Extension 에서 올린 파일이 있는 경우
      // isShowProgressDialog: false,
    }
  },
  mounted() {
    // Chrome extension 에서 녹화해서 넘긴 blob 이 있는지 검사한다.
    // this.checkChromeExtensionClipInfo()
  },
  methods: {
    // Extension 에서 업로드한 클립이 있는지 여부 체크
    // async checkChromeExtensionClipInfo() {
    //   let data
    //   try {
    //     let parsedClipInfo = localStorage.getItem('extensionClipInfo')
    //     console.log('localstorage 에 쌓인 parsedClipInfo 을 검사  ', parsedClipInfo)

    //     if (parsedClipInfo && parsedClipInfo !== '') {
    //       data = JSON.parse(parsedClipInfo)

    //       // this.wsId = data['wsId']
    //       this.thumbnail = data['thumbnail']
    //       this.clipType = data['clipType']
    //       this.duration = data['clipDuration']
    //       this.clipTitle = data['clipTitle']

    //       fetch(data['blobUrl'])
    //         .then((res) => res.blob())
    //         .then((blob) => {
    //           this.blob = blob
    //           // this.isShowProgressDialog = true
    //           this.$emit('openMultipartUpload', this.clipType)

    //           localStorage.removeItem('extensionClipInfo')
    //         })
    //     }
    //   } catch (error) {
    //     console.log('get localstorage error ', error)
    //   }
    // },
    openDialog(type) {
      if (type === 'Attendee') {
        this.attendeeVisible = true
      } else if (type === 'Share') {
        this.isShareDialog = true
      } else if (type === 'MoveToMeeting') {
        this.isMoveToDialog = true
      }
    },
    closeDialog(val) {
      if (val && val.type === 'Attendee') {
        this.attendeeVisible = false
        this.currentMt.mtAttendeeList = val.list
      } else if (val === 'Share') {
        this.isShareDialog = false
      } else if (val === 'MoveToMeeting') {
        this.isMoveToDialog = false
      }
    },
    // Unread Count 를 가져온다.
    // async getMtCnt() {
    //   if (this.selectedWsInfo && this.selectedWsInfo !== null) {
    //     let result = await getMtListCnt(this, this.selectedWsInfo.wsId, '')
    //     if (result && result !== null) this.$store.dispatch('setUnreadCnt', result)
    //   }
    // },
    // 미팅 정보 로드
    async getMtInfo() {
      try {
        await this.$store.dispatch('setIsLoading', true)
        let result = this.chkMtPublic['isPublic']
          ? await getPublicMtInfo(this, this.mtId)
          : await getMtInfo(this, this.wsId, [this.mtId], this.userInfo.userId, true)
        let mtInfo = result.body ? result.body : result && result.length > 0 ? result[0] : null

        if (
          mtInfo === null ||
          (this.$route.name.indexOf('Assigned') === -1 &&
            mtInfo &&
            mtInfo.mtPermission &&
            mtInfo.mtPermission.charAt(0).toUpperCase() !== this.selectedCh['chType'] &&
            this.$route.name.indexOf('Share') === -1)
        ) {
          // notify(this, 'Error', this.$t('general.error'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('general.error'),
              // submsg: '',
            },
          }
          this.$toast.error(content)

          this.$router.replace({
            name: 'Channel',
            params: {
              wsDomain: this.selectedWsInfo ? this.selectedWsInfo['wsDomain'] : this.$route.params.wsDomain,
              chId: this.selectedCh['chId'].replace('CH:', ''),
            },
          })
          // this.$store.dispatch('setSelectedCh', {
          //   chType: this.selectedCh['chType'],
          //   chId: this.selectedCh['chId'].replace('CH:', ''),
          //   chIntegrationInfo: this.selectedCh['chIntegrationInfo'],
          // })
        }

        if (typeof mtInfo === 'string') {
          mtInfo = JSON.parse(mtInfo)
        }
        await store.dispatch('setCurrentMt', mtInfo)

        this.getClipList()
      } catch (error) {
        console.log(error)
        if (error && error.response && error.response !== null && error.response.data === 'NoAccess')
          this.$router.push({
            path: '/no-access/workspace',
            query: {
              wsDomain: this.selectedWsInfo ? this.selectedWsInfo['wsDomain'] : this.$route.params.wsDomain,
            },
          })
      }
    },
    // 클립 리스트 로드
    async getClipList() {
      try {
        let result
        if (this.chkMtPublic['isPublic']) {
          let id
          if (!this.userInfo || this.userInfo === null) id = getSessionId()
          else id = this.userInfo.userId
          result = await getPublicMtClip(this, this.mtId, id)
        } else {
          result = await getClipList(this, this.mtId)
        }
        this.clipList = result

        // for (let clip of this.clipList) {
        //   this.path += clip.clipVersion && clip.clipVersion !== null && clip.clipVersion === 1 ? this.wsId + '/' : ''

        //   if (!clip.clipUrl || clip.clipUrl === '') {
        //     clip.clipUrl = `${this.path}${clip.clipId}.${clip.clipType === 'upload' ? 'mp4' : 'webm'}`
        //   }
        //   if (
        //     (!clip.clipThumbsUrl || clip.clipThumbsUrl === '') &&
        //     clip.clipType !== 'audio' &&
        //     clip.clipType !== 'text'
        //   ) {
        //     clip.clipThumbsUrl = `${this.path}${clip.clipId}.webp`
        //   }
        // }

        // Section 이 추가되면서 Section Clip List 를 추가해준다.
        this.setSectionClipList()
      } catch (error) {
        // console.log(error.response.status, error.response.data)
        console.log(error)
      } finally {
        await this.$store.dispatch('setIsLoading', false)
        this.refreshKey = !this.refreshKey

        // 기존에 미팅 진입 시 watched 넣어주던 부분 삭제
        // if (this.clipList && this.clipList.length > 0 && this.$route.name.indexOf('Share') === -1) {
        //   await watchedClip(this, this.wsId, this.mtId, undefined)
        // }
        this.isLoaded = true

        if (this.selectedWsInfo && this.selectedCh && this.selectedCh['chId']) {
          this.$store.dispatch('getChannelUpdate', {
            wsId: this.wsId,
            chId: this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
            chType: this.selectedCh['chType'],
            chCategory: this.selectedCh['chCategory'],
          })
        }
        // this.getMtCnt()
      }
    },
    async refreshData() {
      this.isLoaded = false
      await store.dispatch('clearClipData')
      this.getMtInfo()

      this.$store.dispatch('getAssignedCnt', this.wsId)
      this.$store.dispatch('getChannelUpdate', {
        wsId: this.wsId,
        chId: this.selectedCh['chId'].includes('CH:') ? this.selectedCh['chId'] : `CH:${this.selectedCh['chId']}`,
        chType: this.selectedCh['chType'],
        chCategory: this.selectedCh['chCategory'],
      })
    },
    async destroy() {
      await store.dispatch('clearClipData')

      localStorage.removeItem('scrollX')
      localStorage.removeItem('scrollY')
      localStorage.removeItem('sectionScrollY')
      localStorage.removeItem('sectionScrollX')
      localStorage.removeItem('currentClip')
      await store.dispatch('setCurrentMt', null)
    },
    async setSectionClipList(argSectionIndex) {
      // Clip List를 생성해준다.
      let clipIndex = 0
      let sectionIndex = 0
      let isReverse = this.currentMt && this.currentMt.mtType === 'chronological' && this.clipSort === 'Latest'
      let currentClip =
        this.clipList && this.clipList !== null && this.clipList.length > 0
          ? this.clipList[isReverse ? this.clipList.length - 1 : 0]
          : {}

      let searchParams = new URLSearchParams(new URL(location.href).search)
      let clipId = searchParams.get('clipId')

      // 진입 시 Clip, Section의 Index 를 세팅해준다.
      let storeClip

      try {
        storeClip = localStorage.getItem('currentClip')
      } catch (e) {
        console.log(e)
      }
      // Clip 선택 후 공유했을 경우
      if (clipId && clipId !== null && clipId !== '') {
        currentClip =
          this.clipList && this.clipList.length > 0 ? this.clipList.find((clip) => clip.clipId === clipId) : {}
        if (!currentClip) {
          currentClip = this.clipList && this.clipList.length > 0 ? this.clipList[0] : {}
          clipIndex = 0
        }
      }
      // 시청중인 Clip 이 있을 경우
      else if (storeClip) {
        let existStoreClip = false
        storeClip = JSON.parse(storeClip)
        if (storeClip && storeClip['clipId'] && storeClip['clipId'] !== '') {
          currentClip =
            this.clipList && this.clipList.length > 0
              ? this.clipList.find((clip) => clip.clipId === storeClip.clipId)
              : {}
          existStoreClip = currentClip && currentClip['clipId'] && currentClip['clipId'] !== ''
        } else {
          existStoreClip = false
        }
        if (!existStoreClip) {
          currentClip = this.clipList && this.clipList.length > 0 ? this.clipList[0] : {}
          clipIndex = 0
          storeClip = null
          localStorage.removeItem('currentClip')
        }
      }

      if (this.selectedWsInfo && this.selectedCh) {
        let routePayload = {
          name: 'ChannelMeetingShare',
          params: {
            wsDomain: this.$route.params['wsDomain'],
            chId: this.selectedCh && this.selectedCh['chId'] ? this.selectedCh['chId'].replace('CH:', '') : '',
            mtId: this.mtId,
          },
        }
        let linkUrl = location.origin + this.$router.resolve(routePayload).href
        window.history.replaceState('', '', linkUrl)
      }

      // Topic List 세팅
      if (this.currentMt.mtType === 'topic') {
        let sectionList = []
        if (
          this.currentMt.sectionInfo &&
          this.currentMt.sectionInfo !== null &&
          this.currentMt.sectionInfo.length > 0
        ) {
          for (let section of this.currentMt.sectionInfo) {
            let tempClipList = []
            if (section.stContentData && section.stContentData !== null && section.stContentData.length > 0) {
              for (let contentData of section.stContentData) {
                let clip = this.clipList.find((clip) => clip.clipId === contentData.contentId)

                if (clip !== undefined && clip !== null) {
                  // section 에 넣었던 embed data 넣어주는 작업으로 변경 20230104
                  if (clip.clipType === 'embed' && !clip.contentData) {
                    clip.contentData = contentData
                  }
                  tempClipList.push(clip)
                }

                // Url Path 에 clipId 가 있는 경우 Section, Current Clip, Clip Index 를 세팅해준다.
                if (clipId && clipId !== null && clipId !== '' && contentData.contentId === clipId) {
                  clipIndex = section.stContentData.findIndex((contentData) => contentData.contentId === clipId)
                  sectionIndex = this.currentMt.sectionInfo.findIndex(
                    (sectionInfo) => sectionInfo.stId === section.stId
                  )
                }
                // 보고있던 클립이 있는 경우 그 미팅으로 초기 세팅해준다.
                else if (
                  storeClip &&
                  storeClip !== null &&
                  storeClip !== 'null' &&
                  contentData.contentId === storeClip.clipId
                ) {
                  clipIndex = section.stContentData.findIndex(
                    (contentData) => contentData.contentId === storeClip.clipId
                  )
                  sectionIndex = this.currentMt.sectionInfo.findIndex(
                    (sectionInfo) => sectionInfo.stId === section.stId
                  )
                }
              }
              section.clipList = tempClipList
            }
            sectionList.push(section)
          }
        }

        if (argSectionIndex && argSectionIndex !== null) sectionIndex = argSectionIndex

        // 시청중인 클립, 공유클립이 아닐 경우 Section List 의 첫번째 클립을 넣어준다.
        if (
          (!clipId || clipId == '') &&
          !storeClip &&
          sectionList &&
          sectionList.length > 0 &&
          sectionList[0].clipList &&
          sectionList[0].clipList.length > 0
        ) {
          currentClip = sectionList[0].clipList[0]
        }
        this.$store.dispatch('setTotalSectionList', sectionList)
      }
      // chronological List
      else if (this.currentMt.mtType === 'chronological') {
        let chronologicalList = []

        let sort1
        let sort2
        switch (this.clipSort) {
          case 'Latest':
            sort1 = 1
            sort2 = -1
            break
          case 'Oldest':
            sort1 = -1
            sort2 = 1
            break
          default:
            break
        }
        await this.clipList.sort((a, b) =>
          b.clipUploadedAt > a.clipUploadedAt ? sort1 : b.clipUploadedAt < a.clipUploadedAt ? sort2 : 0
        )
        for (let clip of this.clipList) {
          if (clip !== undefined && clip !== null) chronologicalList.push({ clipList: [clip] })
        }
        // Url Path 에 clipId 가 있는 경우 Section, Current Clip, Clip Index 를 세팅해준다.
        if (clipId && clipId !== null && clipId !== '') {
          for (let chronologicalIndex in chronologicalList) {
            let chronologicalSection = chronologicalList[chronologicalIndex].clipList
            if (
              chronologicalSection !== undefined &&
              chronologicalSection !== null &&
              chronologicalSection.length > 0
            ) {
              if (chronologicalSection[0].clipId === clipId) {
                clipIndex = 0
                sectionIndex = chronologicalIndex
                break
              }
            }
          }
        }
        // 보고있던 클립이 있는 경우 그 미팅으로 초기 세팅해준다.
        else if (storeClip && storeClip !== null && storeClip !== 'null') {
          for (let chronologicalIndex in chronologicalList) {
            let chronologicalSection = chronologicalList[chronologicalIndex].clipList
            if (
              chronologicalSection !== undefined &&
              chronologicalSection !== null &&
              chronologicalSection.length > 0
            ) {
              if (chronologicalSection[0].clipId === storeClip.clipId) {
                clipIndex = 0
                sectionIndex = chronologicalIndex
                break
              }
            }
          }
        }

        this.$store.dispatch('setTotalSectionList', chronologicalList)
      }
      // 일반 List
      else {
        // Url Path 에 clipId 가 있는 경우 Section, Current Clip, Clip Index 를 세팅해준다.
        if (clipId && clipId !== null && clipId !== '') {
          let index = this.clipList.findIndex((clip) => clip.clipId === clipId)
          if (index >= 0) {
            clipIndex = index
            sectionIndex = 0
          }
        }
        // 보고있던 클립이 있는 경우 그 미팅으로 초기 세팅해준다.
        else if (storeClip && storeClip !== null && storeClip !== 'null') {
          let index = this.clipList.findIndex((clip) => clip.clipId === storeClip.clipId)
          if (index >= 0) {
            clipIndex = index
            sectionIndex = 0
          }
        }

        let defaultList = []
        for (let clip of this.clipList) {
          if (clip !== undefined && clip !== null) defaultList.push(clip)
        }

        this.$store.dispatch('setTotalSectionList', [{ clipList: defaultList }])
      }
      // this.sectionClipList = list

      /**
       * 공유된 클립, 보던 클립 등 이전 상태값을 세팅 해준다.
       */
      this.$store.dispatch('changeCurrentClip', {
        clipIndex: clipIndex,
        sectionIndex: sectionIndex,
        currentClip: currentClip,
        timeStampSeekTime: 0,
      })

      // 스크롤 유지를 위해
      localStorage.setItem('currentClip', JSON.stringify(currentClip))
    },
  },
  beforeDestroy() {
    this.destroy()
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'selectedWsInfo',
      'selectedCh',
      'currentMt',
      'addSection',
      'deleteSection',
      'clipSort',
      'uploadClip',
      'currentClip',
      'chkMtPublic',
    ]),
    mtId() {
      return this.$route.params.mtId
    },
    wsId() {
      let wsId = ''
      if (this.selectedCh && this.selectedCh['wsId'] && this.selectedCh['wsId'] !== '') wsId = this.selectedCh['wsId']
      else if (this.selectedWsInfo && this.selectedWsInfo['wsId'] && this.selectedWsInfo['wsId'] !== '')
        wsId = this.selectedWsInfo['wsId']
      else if (this.currentMt && this.currentMt['wsId'] && this.currentMt['wsId'] !== '') wsId = this.currentMt['wsId']
      return wsId
    },
    mtInfo() {
      return this.currentMt ?? {}
    },
    isClOrganizer() {
      let clipUploader = this.currentClip.clipUploader
      if (clipUploader && this.userInfo) {
        return clipUploader.userId === this.userInfo.userId
      }
      return false
    },
    isMobile() {
      return isMobile()
      // return true
    },
    // Public Meeting 을 가져와야 할 경우를 체크
    isCheckGetPublicMt() {
      return this.chkMtPublic && this.chkMtPublic['isPublic'] && (!this.wsInfo || this.wsInfo === null)
    },
    wsInfo() {
      return this.$store.getters.selectedWsInfo
    },
    clipSort() {
      return this.$store.getters.clipSort
    },
    uploadClip() {
      return this.$store.getters.uploadClip
    },
    deleteClip() {
      return this.$store.getters.deleteClip
    },
    addSection() {
      return this.$store.getters.addSection
    },
    deleteSection() {
      return this.$store.getters.deleteSection
    },
    sectionIndex() {
      return this.$store.getters.sectionIndex
    },
    totalSectionList() {
      return this.$store.getters.totalSectionList
    },
    isLastClip() {
      return this.$store.getters.isLastClip && this.$store.getters.isLastClip !== null
    },
    isNotEmpty() {
      return this.isLoaded && this.clipList !== undefined && this.clipList !== null && this.clipList.length > 0
    },
    isInIframe() {
      return window.location != window.parent.location
      // return true
    },
  },
  watch: {
    drawer() {
      localStorage.setItem('shortcut', this.drawer ? 'true' : 'false')
    },
    uploadClip(val) {
      if (this.currentMt && val && val !== null && val.sectionInfo !== undefined && val.sectionInfo !== null) {
        let sectionInfo = val.sectionInfo
        sectionInfo.stUploaderInfo = this.userInfo
        // 기존에 섹션이 있는 경우 찾아서 변경해준다.
        if (
          this.currentMt.sectionInfo !== undefined &&
          this.currentMt.sectionInfo !== null &&
          this.currentMt.sectionInfo.length > 0
        ) {
          for (let i = 0; i < this.currentMt.sectionInfo.length; i++) {
            if (this.currentMt.sectionInfo[i].stId === sectionInfo.stId) this.currentMt.sectionInfo[i] = sectionInfo
          }
        }
        // 섹션이 없었을 경우 새로운 섹션 정보를 입력해준다.
        else this.currentMt.sectionInfo = [sectionInfo]
      }

      // this.path += val.clipVersion && val.clipVersion !== null && val.clipVersion === 1 ? this.wsId + '/' : ''

      // if (!val.clipUrl || val.clipUrl === '') {
      //   val.clipUrl = `${this.path}${val.clipId}.${val.clipType === 'upload' ? 'mp4' : 'webm'}`
      // }
      // if ((!val.clipThumbsUrl || val.clipThumbsUrl === '') && val.clipType !== 'audio' && val.clipType !== 'text') {
      //   val.clipThumbsUrl = `${this.path}${val.clipId}.webp`
      // }
      val.sectionInfo = undefined

      let temp = this.clipList
      // 기존에 클립이 존재한다면 바꿔주고, 아니면 뒤에 넣어준다.
      let index = temp.findIndex((clip) => clip.clipId === val.clipId)
      if (index >= 0) {
        temp.splice(index, 1, val)
        // this.clipList.splice(index, 0, val)
      } else {
        temp.push(val)
      }

      this.clipList = temp

      // Section 이 추가되면서 Section Clip List 를 추가해준다.
      this.setSectionClipList(this.sectionIndex)
    },
    deleteClip(clipId) {
      if (clipId && clipId !== '') {
        // 기존에 섹션이 있는 경우 찾아서 변경해준다.
        if (
          this.mtInfo.sectionInfo !== undefined &&
          this.mtInfo.sectionInfo !== null &&
          this.mtInfo.sectionInfo.length > 0
        ) {
          let stIndex = this.mtInfo.sectionInfo.findIndex(
            (section) => section.stId === this.totalSectionList[this.sectionIndex].stId
          )
          if (stIndex >= 0 && this.mtInfo.sectionInfo[stIndex] && this.mtInfo.sectionInfo[stIndex].clipList) {
            let index = this.mtInfo.sectionInfo[stIndex].clipList.findIndex((clip) => clip.clipId === clipId)
            if (index >= 0) this.mtInfo.sectionInfo[stIndex].clipList.splice(index, 1)
            localStorage.setItem(
              'currentClip',
              JSON.stringify(
                index - 1 >= 0 && this.mtInfo.sectionInfo[stIndex].clipList.length > index - 1
                  ? this.mtInfo.sectionInfo[stIndex].clipList[index - 1]
                  : null
              )
            )
          }
        }
      }
      let temp = this.clipList
      let index = temp.findIndex((clip) => clip.clipId === clipId)
      if (index >= 0) {
        temp.splice(index, 1)
      }
      this.clipList = temp

      this.setSectionClipList()
    },
    addSection(sectionInfo) {
      if (this.currentMt !== undefined && this.currentMt !== null) {
        if (this.currentMt.sectionInfo !== undefined && this.currentMt.sectionInfo !== null)
          this.currentMt.sectionInfo.push(sectionInfo)
        else this.currentMt.sectionInfo = [sectionInfo]
      }
      // Section 이 추가되면서 Section Clip List 를 추가해준다.
      this.setSectionClipList(this.currentMt && this.currentMt.sectionInfo.length - 1)
    },
    deleteSection(sectionInfo) {
      if (sectionInfo !== undefined && sectionInfo !== null) {
        if (
          this.currentMt.sectionInfo !== undefined &&
          this.currentMt.sectionInfo !== null &&
          this.currentMt.sectionInfo.length > 0
        ) {
          // Meeting 정보에 섹션정보를 삭제해준다.
          let index = this.currentMt.sectionInfo.findIndex((section) => section.stId === sectionInfo.stId)
          if (this.currentMt !== undefined && this.currentMt !== null) this.currentMt.sectionInfo.splice(index, 1)
          // Section 정보에 있는 clipList 를 삭제해준다.
          if (sectionInfo !== undefined && sectionInfo !== null) {
            if (
              sectionInfo.stContentData !== undefined &&
              sectionInfo.stContentData !== null &&
              sectionInfo.stContentData.length > 0
            ) {
              for (let content of sectionInfo.stContentData) {
                let index = this.clipList.findIndex((clip) => clip.clipId === content.contentId)
                if (index >= 0) this.clipList.splice(index, 1)
              }
            }
          }
        }
      }
      // Section 이 추가되면서 Section Clip List 를 추가해준다.
      this.setSectionClipList()
    },
  },
}
</script>
<style scoped>
.container {
  padding: 0 !important;
}
.container-detail {
  display: flex;
}
</style>
